import { useEffect, useState } from "react";
import { useUser } from "@services/UserContext";

export const useCompanyName = () => {
  const [companyName, setCompanyName] = useState<string>("");
  const { user } = useUser();

  useEffect(() => {
    const company = user?.company_relation?.company?.name;
    if (company) {
      setCompanyName(company);
    }
  }, [user]);

  return { companyName };
};
